import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../context/DataContext';
import { featuredLines } from '../data/products';
import './Home.css';

function ProductLineIcon({ id, color }) {
  const icons = {
    healthcare: <svg viewBox="0 0 48 48" fill="none"><rect x="20" y="6" width="8" height="36" rx="4" fill={color} opacity="0.2"/><rect x="6" y="20" width="36" height="8" rx="4" fill={color} opacity="0.2"/><rect x="22" y="8" width="4" height="32" rx="2" fill={color}/><rect x="8" y="22" width="32" height="4" rx="2" fill={color}/></svg>,
    personalcare: <svg viewBox="0 0 48 48" fill="none"><path d="M24 40 C24 40 8 30 8 18 C8 12 13 7 19 7 C21.5 7 23.5 8 24 9 C24.5 8 26.5 7 29 7 C35 7 40 12 40 18 C40 30 24 40 24 40Z" fill={color} opacity="0.2"/><path d="M24 38 C24 38 10 28.5 10 18 C10 13.5 14 9 19 9 C21.5 9 23 10 24 11.5 C25 10 26.5 9 29 9 C34 9 38 13.5 38 18 C38 28.5 24 38 24 38Z" fill={color}/></svg>,
    babycare: <svg viewBox="0 0 48 48" fill="none"><ellipse cx="24" cy="28" rx="12" ry="14" fill={color} opacity="0.2"/><ellipse cx="24" cy="28" rx="9" ry="11" fill={color}/><ellipse cx="24" cy="15" rx="5" ry="6" fill={color} opacity="0.7"/><rect x="21" y="8" width="6" height="4" rx="2" fill={color} opacity="0.5"/></svg>,
    dental: <svg viewBox="0 0 48 48" fill="none"><path d="M16 8 C10 8 8 14 8 18 C8 26 14 32 16 40 C17 40 18 36 20 32 C21 28 23 26 24 26 C25 26 27 28 28 32 C30 36 31 40 32 40 C34 32 40 26 40 18 C40 14 38 8 32 8 C28 8 26 10 24 10 C22 10 20 8 16 8Z" fill={color} opacity="0.25"/><path d="M18 10 C12 10 10 15 10 18 C10 25 16 31 18 38 C19 38 20 35 22 31 C23 28 23.5 26 24 26 C24.5 26 25 28 26 31 C28 35 29 38 30 38 C32 31 38 25 38 18 C38 15 36 10 30 10 C27 10 25.5 12 24 12 C22.5 12 21 10 18 10Z" fill={color}/></svg>,
    laboratory: <svg viewBox="0 0 48 48" fill="none"><rect x="18" y="6" width="12" height="30" rx="6" fill={color} opacity="0.2"/><rect x="20" y="8" width="8" height="26" rx="4" fill={color}/><rect x="16" y="34" width="16" height="8" rx="4" fill={color} opacity="0.7"/><circle cx="24" cy="14" r="3" fill="white"/></svg>,
    physiotherapy: <svg viewBox="0 0 48 48" fill="none"><circle cx="24" cy="12" r="6" fill={color} opacity="0.3"/><circle cx="24" cy="12" r="4" fill={color}/><path d="M14 22 C14 18 18 16 24 16 C30 16 34 18 34 22 L34 30 C34 32 32 34 30 34 L18 34 C16 34 14 32 14 30 Z" fill={color} opacity="0.2"/><path d="M16 22 C16 19 19 17 24 17 C29 17 32 19 32 22 L32 30 C32 31.5 31 33 29 33 L19 33 C17 33 16 31.5 16 30 Z" fill={color}/><path d="M20 34 L18 42 M28 34 L30 42" stroke={color} strokeWidth="3" strokeLinecap="round"/></svg>,
    hospitality: <svg viewBox="0 0 48 48" fill="none"><path d="M10 20 C10 20 10 10 24 10 C38 10 38 20 38 20 L38 26 C38 34 32 40 24 40 C16 40 10 34 10 26 Z" fill={color} opacity="0.2"/><path d="M12 20 C12 20 12 12 24 12 C36 12 36 20 36 20 L36 26 C36 33 31 38 24 38 C17 38 12 33 12 26 Z" fill={color}/><path d="M18 20 L30 20" stroke="white" strokeWidth="2" strokeLinecap="round"/><path d="M16 25 L32 25" stroke="white" strokeWidth="2" strokeLinecap="round"/></svg>,
    industrial: <svg viewBox="0 0 48 48" fill="none"><rect x="8" y="20" width="32" height="20" rx="3" fill={color} opacity="0.2"/><rect x="10" y="22" width="28" height="16" rx="2" fill={color}/><path d="M16 22 L16 16 L24 10 L32 16 L32 22" fill={color} opacity="0.5"/><rect x="20" y="30" width="8" height="8" rx="1" fill="white" opacity="0.6"/></svg>,
    emergency: <svg viewBox="0 0 48 48" fill="none"><path d="M24 6 L28 18 L40 18 L31 26 L34 38 L24 31 L14 38 L17 26 L8 18 L20 18 Z" fill={color} opacity="0.2"/><path d="M24 8 L27.5 19 L39 19 L30 26.5 L33 38 L24 32 L15 38 L18 26.5 L9 19 L20.5 19 Z" fill={color}/></svg>,
    athlete: <svg viewBox="0 0 48 48" fill="none"><circle cx="24" cy="24" r="16" fill={color} opacity="0.2"/><circle cx="24" cy="24" r="12" fill={color}/><path d="M24 16 L26.5 21.5 L33 22.5 L28.5 27 L29.5 33.5 L24 30.5 L18.5 33.5 L19.5 27 L15 22.5 L21.5 21.5 Z" fill="white"/></svg>,
  };
  return <div className="line-icon">{icons[id] || icons.healthcare}</div>;
}

const stats = [
  { value: '10+', label: 'Product Sectors' },
  { value: '80+', label: 'Product SKUs' },
  { value: 'ISO', label: '9001:2015 Certified' },
  { value: 'FDA', label: 'Approved' },
];

const whyUsData = [
  { iconId: 'manufacturing', title: 'Own Manufacturing', desc: 'In-house production facility in Vasai, Maharashtra with stringent quality control at every stage of production.' },
  { iconId: 'medical', title: 'Medical Grade Materials', desc: 'Certified food-grade and medical-grade rubber & silicone — safe for patients, babies, and consumers.' },
  { iconId: 'bulk', title: 'Bulk & Custom Orders', desc: 'Flexible MOQ with custom sizing, branding, and packaging for hospitals, distributors, and retailers.' },
  { iconId: 'delivery', title: 'Pan-India Delivery', desc: 'Fast, reliable delivery across India with proper packaging to maintain product integrity throughout transit.' },
  { iconId: 'iso', title: 'ISO 9001:2015', desc: 'Certified quality management system ensuring consistent product standards and continuous improvement.' },
  { iconId: 'support', title: 'Dedicated Support', desc: 'Direct line to our sales team for technical queries, product samples, and after-sales support.' },
];

function WhyIcon({ id }) {
  const icons = {
    manufacturing: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="32" height="32"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/><line x1="12" y1="12" x2="12" y2="16"/><line x1="10" y1="14" x2="14" y2="14"/></svg>,
    medical: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="32" height="32"><path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2v-4M9 21H5a2 2 0 0 1-2-2v-4m0 0h18"/></svg>,
    bulk: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="32" height="32"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>,
    delivery: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="32" height="32"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 4v4h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>,
    iso: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="32" height="32"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>,
    support: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="32" height="32"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
  };
  return icons[id] || null;
}

export default function Home() {
  const { productLines, companyInfo } = useData();
  const statsRef = useRef(null);
  const featured = productLines.filter(l => featuredLines.includes(l.id));

  return (
    <main className="home">

      {/* Hero */}
      <section className="hero">
        <div className="hero-bg">
          <div className="hero-blob hero-blob-1" />
          <div className="hero-blob hero-blob-2" />
          <div className="hero-grid" />
        </div>
        <div className="container hero-inner">
          <div className="hero-content">

            <h1 className="hero-title">
              Healthcare Products <br />
              <em>You Can Trust</em>
            </h1>
            <p className="hero-subtitle">
              Medical-grade rubber & silicone products crafted for hospitals, homes, mothers, athletes, and kitchens. Precision-made in India across 10 specialised sectors.
            </p>
            <div className="hero-actions">
              <Link to="/products" className="btn-primary">Explore Products</Link>
              <Link to="/contact" className="btn-outline">Request a Sample</Link>
            </div>
            <div className="hero-certs">
              {companyInfo.certifications.map(c => (
                <span key={c} className="hero-cert">{c}</span>
              ))}
            </div>
          </div>
          <div className="hero-visual">
            <div className="hero-card-stack">
              <div className="hero-card hc-1">
                <div className="hc-icon">🏥</div>
                <div>
                  <div className="hc-title">MedCore</div>
                  <div className="hc-sub">Clinical Supplies</div>
                </div>
              </div>
              <div className="hero-card hc-2">
                <div className="hc-icon">👶</div>
                <div>
                  <div className="hc-title">NeoCare</div>
                  <div className="hc-sub">Mother & Baby</div>
                </div>
              </div>
              <div className="hero-card hc-3">
                <div className="hc-icon">🦷</div>
                <div>
                  <div className="hc-title">DentaCare</div>
                  <div className="hc-sub">Dental Care</div>
                </div>
              </div>
              <div className="hero-main-img">
                <img src="https://images.unsplash.com/photo-1631815589968-fdb09a223b1e?w=500&q=80" alt="Medical supplies" />
                <div className="hero-img-overlay">
                  <span>80+ Products</span>
                  <span>10 Sectors</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="stats-bar" ref={statsRef}>
        <div className="container stats-inner">
          {stats.map((s, i) => (
            <div key={i} className="stat-item">
              <div className="stat-value">{s.value}</div>
              <div className="stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Company Description */}
      <section className="company-desc-section">
        <div className="container company-desc-inner">
          <div className="company-desc-text">
            <span className="section-tag">Who We Are</span>
            <h2 className="section-title">About <em>OM Cares</em></h2>
            <p className="company-desc-para">
              <strong>OM Cares</strong> is a trusted manufacturer and supplier of high-quality rubber, silicone, and polymer-based healthcare, consumer, and utility products — designed to improve safety, hygiene, and everyday comfort.
            </p>
            <p className="company-desc-para">
              Built on strong manufacturing expertise in precision rubber and silicone molding, we serve multiple sectors including healthcare, personal care, baby care, sports, laboratories, hospitality, and household applications — all from our facility in Vasai, Maharashtra.
            </p>
            <div className="company-desc-pills">
              <span className="desc-pill">🏭 Own Manufacturing Unit</span>
              <span className="desc-pill">🇮🇳 Made in India</span>
              <span className="desc-pill">📦 Bulk Orders Welcome</span>
              <span className="desc-pill">🚚 Pan-India Delivery</span>
            </div>
          </div>
          <div className="company-desc-visual">
            <div className="desc-stat-card">
              <span className="dsc-val">10</span>
              <span className="dsc-label">Product Sectors</span>
            </div>
            <div className="desc-stat-card highlight">
              <span className="dsc-val">80+</span>
              <span className="dsc-label">Products</span>
            </div>
            <div className="desc-stat-card">
              <span className="dsc-val">ISO</span>
              <span className="dsc-label">9001:2015</span>
            </div>
            <div className="desc-stat-card">
              <span className="dsc-val">FDA</span>
              <span className="dsc-label">Approved</span>
            </div>
          </div>
        </div>
      </section>

      {/* Product Lines — Featured 6 */}
      <section className="product-lines-section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Our Portfolio</span>
            <h2 className="section-title">Sectors We Serve</h2>
            <p className="section-desc">From operating theatres to home kitchens — every product engineered for performance and safety.</p>
          </div>
          <div className="product-lines-grid">
            {featured.map((line, i) => (
              <Link to={`/products?line=${line.id}`} key={line.id}
                className="product-line-card"
                style={{ '--line-color': line.color, '--line-light': line.lightColor, animationDelay: `${i * 0.08}s` }}>
                <div className="plc-header">
                  <ProductLineIcon id={line.id} color={line.color} />
                  <div className="plc-count">{line.products.length} products</div>
                </div>
                <div className="plc-img">
                  <img src={line.image} alt={line.name} loading="lazy" />
                </div>
                <div className="plc-body">
                  <h3>{line.name}</h3>
                  <p className="plc-subtitle">{line.subtitle}</p>
                  <p className="plc-desc">{line.description}</p>
                </div>
                <div className="plc-footer">
                  <span>View All Products</span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="m9 18 6-6-6-6"/></svg>
                </div>
              </Link>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: '32px' }}>
            <Link to="/products" className="btn-primary">View All 10 Sectors →</Link>
          </div>
        </div>
      </section>

      {/* Why Us */}
      <section className="why-section">
        <div className="why-bg" />
        <div className="container">
          <div className="section-header light">
            <span className="section-tag light">Why OM Cares</span>
            <h2 className="section-title light">Built on Trust, Backed by Quality</h2>
          </div>
          <div className="why-grid">
            {whyUsData.map((item, i) => (
              <div key={i} className="why-card" style={{ animationDelay: `${i * 0.1}s` }}>
                <div className="why-icon"><WhyIcon id={item.iconId} /></div>
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container cta-inner">
          <div className="cta-content">
            <h2>Ready to place an enquiry?</h2>
            <p>Contact our sales team for pricing, samples, and custom orders.</p>
          </div>
          <div className="cta-actions">
            <Link to="/contact" className="btn-primary">Send Enquiry</Link>
            <a href={`https://wa.me/${companyInfo.whatsapp}`} target="_blank" rel="noopener noreferrer" className="btn-whatsapp">
              <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.123.555 4.116 1.528 5.845L0 24l6.335-1.652A11.954 11.954 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.885 0-3.652-.51-5.166-1.4l-.371-.22-3.761.98.998-3.662-.241-.379A9.956 9.956 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/></svg>
              WhatsApp Us
            </a>
          </div>
        </div>
      </section>

    </main>
  );
}
